// Vendor
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useMutation } from "react-apollo";
import { Button } from "reactstrap";

// App
import Auth from "common/Auth";
import LocaleHelper from "common/LocaleHelper";
import { UPDATE_USER_PROFILE_MUTATION } from "common/Mutations";
import FlagIcon from "components/ui/FlagIcon";

function LanguageList(props) {
  const user = Auth.getUser();
  const [language, setLanguage] = useState(LocaleHelper.getLocale().language);

  const [updateUserProfile] = useMutation(UPDATE_USER_PROFILE_MUTATION, {
    onCompleted: () => Auth.setUser({ ...user, language })
  });

  return LocaleHelper.getLocales().map((locale, index) => (
    <Button
      color="link"
      className={`${props.className} ${
        language === locale.language ? "active" : ""
      }`}
      key={index}
      onClick={() => handleLanguageChange(locale)}
    >
      <FlagIcon code={locale.country} className="mr-2" />
      {locale.label}
    </Button>
  ));

  function handleLanguageChange(locale) {
    const { language } = locale;

    // store for updating user profile after save
    setLanguage(language);

    // callback
    props.onChange(locale);

    if (props.updateLangOnChange) {
      // Globally update language in app
      LocaleHelper.load(language);

      // Update user in local storage if signed in
      if (user) {
        updateUserProfile({
          variables: {
            input: {
              firstName: user.firstName,
              lastName: user.lastName,
              newsletter: user.newsletter,
              language
            }
          }
        });
      }
    }
  }
}

LanguageList.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  updateLangOnChange: PropTypes.bool.isRequired
};

LanguageList.defaultProps = {
  className: "",
  onChange: () => null,
  updateLangOnChange: true
};

export default LanguageList;
